import { render, staticRenderFns } from "./painPoint.vue?vue&type=template&id=63222e3a&scoped=true"
import script from "./painPoint.vue?vue&type=script&lang=js"
export * from "./painPoint.vue?vue&type=script&lang=js"
import style0 from "./painPoint.vue?vue&type=style&index=0&id=63222e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63222e3a",
  null
  
)

export default component.exports